import * as STD                                  from '@emersya/mpa-std-lib';
import CM                                        from '@emersya/mpa-components-manager-lib';
import { Loader as LoaderNS, Input as InputNS, } from '@emersya/mpa-components-lib';
import * as BasketNS from '@emersya/mpa-basket-lib';
import './Application.scss';

export interface IApplicationComponentConfiguration extends CM.DOMComponent.IConfiguration {
	// readonly devAssetsURL : string | null;
	// readonly controllerName : string;
	readonly replayURL : string;
	readonly productionAppCode : string;
	readonly productionCustomerCode : string;
	readonly languages : {
		readonly list : {
			readonly  id : string;
			readonly  name : string;
		}[];
		readonly default : string;
	};
	readonly countries : {
		readonly list : {
			readonly  id : string;
			readonly  currencyId : string;
			readonly  VAT : number;
		}[];
		readonly default : string;
	};
	readonly currencies : {
		readonly list : {
			readonly  id : string;
			readonly  symbol : string;
		}[];
	};
	/** Used to sort user inputs before replay, small numbers are applied before. **/
	readonly replayUserInputsSorter? : (
		path : string,
		boundComponent : CM.Component<any, any>,
		currentOrder : number
	) => number;
};
export type TMessageslistenerComponent = CM.Component.TAny & {
	readonly  onMessage : (event : MessageEvent) => Promise<void> | void;
};

export class ApplicationComponent<
	TComponent extends ApplicationComponent<TComponent, TConfiguration>,
	TConfiguration extends IApplicationComponentConfiguration
> extends CM.DOMComponent<
	HTMLDivElement,
	ApplicationComponent<TComponent, TConfiguration>,
	TConfiguration
>
{
	static count = 0;
	static managerManifest : CM.Manifest.ManagerManifest;
	static clientAppParameters : NS.IClientAppParameters;

	/*
		Implement this static method in your application specific class to update if necessary the configuration before it will be used.
		If the configuration do not need update, simply implement it without doing anything.
		You must edit "this.managerManifest.configurations" for your's modifications to be taken into account.
		/!\ Is an abstract static method but TS doesnt support this so do black magick!
	*/
	static configurationNormalize() : void {
		throw STD.errors.library('"configurationNormalize" is an abstract method, your application should implement it!', {
			currentApplicationClass : this
		});
		//@ts-ignore
		return <unknown> void 1;
	};

	static override initialize() {
		CM.DOMComponent.initialize.call(this);
	};

	//load the dependencies + instantiate the app
	static async run() {
		if (this.count !== 0) {
			throw STD.errors.user('Only one application component is allowed!');
		}
		try {
			await STD.DOM.awaitDocumentIsInteractive();
			ApplicationComponent.clientAppParameters = (<any> window).serverParameters;
			if (typeof this.clientAppParameters !== 'object') {
				throw new Error;
			}
			STD.DOM.openFilesSelector.initialize(document.body as HTMLBodyElement);
			CM.initialize(() => {
			});
			const confDownloadResponse = await fetch(this.clientAppParameters.app.configuration.currentPath);
			const configuration = (await confDownloadResponse.text()).replace(
				/\$ASSETS\//gm,
				this.clientAppParameters.app.assetsPath
			).replace(
				/CH1U0ZGKSI/gm,
				'E3GC4QDIZW'
			).replace(
				/XUJG0A2TF5/gm,
				'STAODAZNIS'
			).replace(
				/sam1_12345/gm,
				'STAODAZNIS'
			);
			const manifest = CM.Manifest.create(
				this.clientAppParameters.app.configuration.currentPath,
				configuration,
				'manager'
			);
			this.managerManifest = manifest;
			this.configurationNormalize();
			const confK


							= <IApplicationComponentConfiguration | null> this.managerManifest.treeNodes.find(x => x.id ===
				'K')?.configuration || null;
			if (!confK) {
				throw new Error;
			}
			STD.translationsManager.initialize({
				languages :       confK.languages.list.map(x => x.id),
				defaultLanguage : confK.languages.default,
				translations :    {} // Dynamically filled.
			});
			STD.translationsManager.use(this.clientAppParameters.user.lang);
			const rootComponent = <CM.DOMComponent<any, any, any>> await manifest.instantiate();
			if (!(rootComponent instanceof ApplicationComponent)) {
				throw STD.errors.user(
					'Root component must be an ApplicationComponent!',
					{ rootComponent }
				);
			}
			document.body.appendChild(rootComponent.component_DOM);
			await rootComponent.component_start(rootComponent.component_getEventWhichRepresentNoEvent());
			await rootComponent.component_dispatchVisibilityUpdate(true);
			return rootComponent;
		} catch (error : any) {
			throw STD.errors.bind('Cannot initialize the application', {}, error);
		}
	};

	readonly parameters = STD.net.URL_parse(location).parameters;
	component_DOM : HTMLDivElement;
	loader : LoaderNS.Component | null = null;
	currentlyHovered : null | {
		node : Node;
		component : CM.DOMComponent<any, any, any> | null;
	} = null;

	messagesListeners : WeakMap<Window | MessagePort | ServiceWorker, TMessageslistenerComponent> = new WeakMap;

	private _currentCountry : string;

	private unusableCount = 0;

	get currentLanguage() {
		return STD.translationsManager.language;
	};

	get currentCountry() {
		const country = this.component_configuration.countries.list.find(x => x.id === this._currentCountry);
		if (!country) {
			this.component_throwLibraryError('');
		}
		return country;
	};

	get currentCurrency() {
		const country = this.currentCountry;
		const currency = this.component_configuration.currencies.list.find(x => x.id === country.currencyId);
		if (!currency) {
			this.component_throwLibraryError('');
		}
		return currency;
	};

	get code() {
		if (!this.clientAppParameters.server.isOnProd) {
			return app.parameters.useLocalViewers ?
				this.clientAppParameters.app.code :
				this.component_configuration.productionAppCode;
		}
		return this.clientAppParameters.app.code;
	};

	get configurationFileVersionId() {
		return this.clientAppParameters.app.configuration.versionId;
	};

	async controllerGET(descriptor : {
		readonly route : string;
		readonly parameters : Record<string, string>;
		readonly headers : Record<string, string>;
	}) : Promise<Response> {
		const URL = STD.net.URL_format(
			`${ this.clientAppParameters.app.URLPrefix }${ descriptor.route }`,
			descriptor.parameters
		);
		return await fetch(URL, {
			method :  'GET',
			mode :    'cors',
			cache :   'no-cache',
			headers : descriptor.headers
		});
	};

	async controllerPOST(descriptor : {
		readonly route : string;
		readonly parameters : Record<string, string>;
		readonly headers : Record<string, string>;
		readonly body : BodyInit | null;
	}) : Promise<Response> {
		const URL = STD.net.URL_format(
			(app.clientAppParameters.server.isOnProd || app.parameters.useLocalViewers) ?
				`${ this.clientAppParameters.app.URLPrefix }${ descriptor.route }` :
				`https://emersya.com/${ this.currentLanguage }/${ this.clientAppParameters.app.isTestMode ?
					'testApp' :
					'app' }/${ this.component_configuration.productionAppCode }/${ descriptor.route }`,
			descriptor.parameters
		);
		const response = await fetch(URL, {
			method :  'POST',
			mode :    'cors',
			cache :   'no-cache',
			body :    descriptor.body,
			headers : descriptor.headers
		});
		if (!response.ok) {
			const errorText = await response.text();
			let shouldRethrowNewError = true;
			try {
				const emersyaError = JSON.parse(errorText);
				shouldRethrowNewError = false;
				throw STD.errors.library(emersyaError.description, { response, emersyaError });
			} catch (error) {
				if (shouldRethrowNewError) {
					throw STD.errors.library(errorText, { response });
				}
				throw error;
			}
		}
		return response;
	};

	get clientAppParameters() {
		return ApplicationComponent.clientAppParameters;
	};

	setAppUsable() {
		this.unusableCount--;
		if (this.unusableCount !== 0) {
			return;
		}
		document.body.style.cursor = '';
		this.component_DOM.classList.remove('unusable');
	};

	setAppUnusable() {
		this.unusableCount++;
		document.body.style.cursor = 'wait';
		// do not set app as unusable when loader displayed because its collide with loader style
		if ((this.component_findOuter([ 'loader' ]) as any).isVisible) {
			return;
		}
		this.component_DOM.classList.add('unusable');
	};

	disablePointerEvents() {
		this.component_DOM.style.pointerEvents = 'none';
	};

	enablePointerEvents() {
		this.component_DOM.style.pointerEvents = '';
	};

	disablePointerSelection() {
		this.component_DOM.style.userSelect = 'none';
	};

	enablePointerSelection() {
		this.component_DOM.style.userSelect = '';
	};

	getAllSerializableUserInputs() {
		const allSerializableInputs = <InputNS.Component<any, any, any, any, any>[]> this.getAllChilds().
		filter(x => x instanceof InputNS.Component);
		const unwantedInputs = allSerializableInputs.filter(x => x.component_configuration.disableMPAEngineAutoSerialization);
		const maybeWantedInput = allSerializableInputs.filter(x => !unwantedInputs.includes(x));
		const unwantedInputsPath = unwantedInputs.map(x => x.component_getPath());
		const wantedInputs = maybeWantedInput.filter(x => {
			const currentPath = x.component_getPath();
			return unwantedInputsPath.every(unwantedPath => !currentPath.startsWith(unwantedPath));
		});
		return wantedInputs;
	};

	async getAndSerializeAllUserInputsData() : Promise<[ CM.Path.TPathRaw, unknown ][]> {
		const allAppInputs = (
			(await Promise.all(
				this.getAllSerializableUserInputs().
				map<Promise<[ string, unknown ]>>(async (x) => [ x.component_getPath(), await x.getUserValueSerialized() ])
			)).
			filter(x => x[ 1 ] !== null)
		);
		return allAppInputs;
	};

	async setAndDeserializeAllUserInputsData(
		userInputs : [ CM.Path.TPathRaw, unknown ][]
	)
	{
		const defaultGetNewOrder = (
			path : string,
			boundComponent : CM.Component<any, any>,
			currentOrder : number
		) => {
			void path;
			void boundComponent;
			return currentOrder;
		};
		const getNewOrder = this.component_configuration.replayUserInputsSorter || defaultGetNewOrder;
		let toBeDeserialized = Array.from(userInputs).filter(x => !x[ 0 ].startsWith('K.visualization.V.viewer-menu'));
		let hasDoneChanges = true;
		while (toBeDeserialized.length && hasDoneChanges) {
			hasDoneChanges = false;
			const {
							remaining,
							toDeserializeThisStep
						} = toBeDeserialized.reduce<{
				readonly remaining : typeof toBeDeserialized;
				readonly toDeserializeThisStep : [ string, InputNS.Component<any, any, any, any, any>, number, unknown ][];
			}>((a, [ path, value ], i) => {
				const component = this.component_findMaybe(path);
				if (!component) {
					a.remaining.push([ path, value ]);
				} else if (!(component instanceof InputNS.Component)) {
					this.component_throwUserError(
						`Given user input do not match current tree, component<${ path }> is not an input!`,
						{
							userInputs,
							path,
							value,
							component
						}
					);
				} else {
					//  this is really necessary??!
					if (component.static.type !== 'viewer-graphics') {
						a.toDeserializeThisStep.push([ path, component, getNewOrder(path, component, i + 1000), value ]);
						// continue;
					}
				}
				return a;
			}, {
				remaining :             [],
				toDeserializeThisStep : []
			});
			toBeDeserialized = remaining;
			toDeserializeThisStep.sort((a, b) => a[ 2 ] - b[ 2 ]);
			if (toDeserializeThisStep.length) {
				hasDoneChanges = true;
			}
			for (const [ unused0, component, unused1, value ] of toDeserializeThisStep) {
				void [ unused0, unused1 ];
				await component.updateValue(await component.deserialize(value));
			}
		}
		if (toBeDeserialized.length) {
			this.component_throwLibraryError('Cannot deserialize all data!', {
				undeserializable : toBeDeserialized
			});
		}
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		const loader = <LoaderNS.Component | undefined> this.component_outerChilds.find(
			x => x instanceof LoaderNS.Component
		);
		if (loader) {
			this.loader = loader;
			await this.loader.update('app.load', null);
		}
		STD.translationsManager.update(document.body);
		await super.component_start(startEvent);
	};

	getAppURL() {
		const CAP = this.clientAppParameters;
		const appMode = CAP.app.isTestMode ? 'testApp' : 'app';
		return `${ CAP.server.protocol }${ CAP.server.domain }/${ this.currentLanguage }/${ appMode }/${ this.code }`;
	};

	async loadSavedConfigurationMetadata() {
		const s = this.clientAppParameters;
		if (!s.app.savedConfigurationCode) {
			return null;
		}
		const requestURL = STD.net.URL_format(s.server.webserviceURL + '/configuration/metadata/getPath', {
			configurationCode : s.app.savedConfigurationCode
		});
		const response = (await (await fetch(requestURL)).json()).resultSet;
		if (response.error) {
			this.component_throwUserError(response.error);
		}
		const metadata = await fetch(response.data[ 0 ]);
		return metadata;
	};

	protected override async component_finalize() {
		await super.component_finalize();
		STD.translationsManager.update(document.body);
	};

	private async onBeforeUnload(nativeEvent : BeforeUnloadEvent) { // eslint-disable-line require-await
		nativeEvent.preventDefault();
		nativeEvent.returnValue =
			'Application is going to close and all unsaved works will be lost.\nWould you like to continue?';
		return ('Application is going to close and all unsaved works will be lost.\nWould you like to continue?');
	};

	private onMouseMove(nativeEvent : MouseEvent) {
		const node = <HTMLElement> nativeEvent.target;
		if (!node) {
			return;
		}
		if (this.component_DOM.contains(node)) {
			const hoveredComponent = CM.DOMComponent.getFromDOM(node);
			if (this.currentlyHovered) {
				this.currentlyHovered.component = hoveredComponent;
				this.currentlyHovered.node = node;
			} else {
				this.currentlyHovered = {
					component : hoveredComponent,
					node :      node
				};
			}
		} else {
			this.currentlyHovered = null;
		}
	};

	private onMouseOut(nativeEvent : MouseEvent) {
		if (!nativeEvent.relatedTarget) {
			this.currentlyHovered = null;
		} else {
			//Handle the case where an iframe is hovered
		}
	};

	private async onMessage(event : MessageEvent) {
		if (!event.data || !event.source) {
			return;
		}
		const handler = this.messagesListeners.get(event.source);
		if (!handler) {
			return;
		}
		await handler.onMessage(event);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : TConfiguration
	)
	{
		super(descriptor, Object.assign(
			{
				'@preventDefaultDisplayNone' : true
			},
			configuration
		));
		if (ApplicationComponent.count !== 0) {
			throw STD.errors.user('Only one application component is allowed!');
		}
		ApplicationComponent.count++;
		if (!(<any> window).app) {
			(<any> window).app = this;
		}
		BasketNS.Basket.currentApplication = <any>this;
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
		const currentCountry = configuration.countries.list.find(x => x.id === configuration.countries.default);
		if (!currentCountry) {
			this.component_throwLibraryError('');
		}
		this._currentCountry = currentCountry.id;
		window.addEventListener('message', this.onMessage.bind(this));
		window.addEventListener('mousemove', this.onMouseMove.bind(this), true);
		window.addEventListener('mouseout', this.onMouseOut.bind(this), true);
		window.addEventListener('beforeunload', this.onBeforeUnload.bind(this), true);
	};
};
export namespace NS {
	export const Component = ApplicationComponent;
	export type Component = ApplicationComponent<any, any>;
	export type Configuration = IApplicationComponentConfiguration;

	export interface IClientAppParameters {
		readonly server : {
			readonly protocol : string;
			readonly domain : string;
			readonly host : string;
			readonly isOnProd : boolean;
			readonly webserviceURL : string;
		};
		readonly user : {
			readonly lang : string;
			readonly geolocation? : {
				readonly continent : {
					readonly code : string;
				};
				readonly country : {
					readonly code : string;
					readonly locales : string;
				};
			};
		};
		readonly app : {
			readonly code : string;
			readonly isJS : boolean;
			readonly isTestMode : boolean;
			readonly customerCode : string;
			readonly assetsPath : string;
			readonly URLPrefix : string;
			readonly savedConfigurationCode : string;
			readonly savedBasket : string | null;
			readonly savedBasketProductCode : string | null;
			readonly viewer : {
				readonly route : string;
				readonly routingCode : string;
				readonly useShowcaseDev : string;
				readonly URL : string;
			};
			readonly configuration : {
				readonly path : string;
				readonly versionId : string | null;
				readonly extension : 'xml' | 'json';
				readonly remotePath : string;
				readonly currentPath : string;
				readonly isExternalUsed : boolean;
			};
		};
		readonly  methodsStoreIdentifier : string;
		readonly  methodsStore : {
			readonly getViewerURL : (
				viewerCode : string,
				options : {
					readonly forceLocal? : boolean;
				}
			) => string;
			readonly getCDNFileURL : (fileName : string) => string;
			readonly getRemoteCDNFileURL : (fileName : string) => string;
			readonly getLatestRemoteCDNFileURL : (fileName : string) => string;
			readonly getAssetFileURL : (fileName : string) => string;
			readonly getRemoteAssetFileURL : (fileName : string) => string;
			readonly getLatestRemoteAssetFileURL : (fileName : string) => string;
		};
	};
}

CM.declare({
	id :   'application',
	type : ApplicationComponent
});
